import { QuestionPlanOnlyUseCreditPayment as Question } from "@/components/features/items/edit/plan/_shared/ui/components/plan-attributes/only-use-credit-payment";

import { usePlanOnlyUseCreditPayment } from "./hooks";

export const QuestionPlanOnlyUseCreditPayment = () => {
	const { onlyUseCreditPayment, onSetOnlyUseCreditPayment } = usePlanOnlyUseCreditPayment();

	return (
		<Question onSetOnlyUseCreditPayment={onSetOnlyUseCreditPayment} onlyUseCreditPayment={onlyUseCreditPayment} />
	);
};

QuestionPlanOnlyUseCreditPayment.displayName = "QuestionPlanOnlyUseCreditPayment";
